import { inject, Injectable } from '@angular/core';
import { ApiKeyRecord, CreatedApiKeyRecord, PagingResponse } from '../models/cms-models';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})
export class ApiKeysService {
  private apiService = inject(ApiService);

  async getSiteApiKeys(siteId: string): Promise<ApiKeyRecord[]> {
    const response = await this.apiService.get<PagingResponse<ApiKeyRecord>>(`api/key/site/${siteId}`);
    return response.data;
  }

  async createApiKey(siteId: string, name: string): Promise<CreatedApiKeyRecord> {
    return this.apiService.post<CreatedApiKeyRecord, { name: string; siteId: string }>('api/key', { name, siteId });
  }

  async deleteApiKey(id: string): Promise<void> {
    await this.apiService.delete(`api/key/${id}`);
  }
}
